import React, { useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import PieChart from "./pieChart";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";

am4core.useTheme(am4themes_animated);

export default function TraingleChart(props) {
  const [showEbuCbu, setShowEbuCbu] = useState(false);
  const [showColumnChart, setShowColumnChart] = useState(false);
  console.log("---props---->>>>>>>>>>>>>>>>>>>>", props);
  const handleTypesClick = () => {
    setShowEbuCbu(false);
    setShowColumnChart(false);
  };

  const handleCbuClick = () => {
    setShowColumnChart(false);
  };

  return (
    <div style={{ width: "100%" }}>
      {props?.showMnpData && showEbuCbu ? (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginTop: 16 }}>
          <Button color="primary" size="small" onClick={handleTypesClick}>
            Types
          </Button>
          <Button
            disabled={!showColumnChart}
            color="primary"
            size="small"
            onClick={handleCbuClick}
          >
            Hayyak-Baqati
          </Button>
          {showColumnChart ? (
            <Button disabled color="inherit" size="small" onClick={() => null}>
              Sales
            </Button>
          ) : null}
        </Breadcrumbs>
      ) : null}
      {!props?.showMnpData && showEbuCbu ? (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginTop: 16 }}>
          <Button color="primary" size="small" onClick={handleTypesClick}>
            Types
          </Button>
          <Button
            disabled={!showColumnChart}
            color="primary"
            size="small"
            onClick={handleCbuClick}
          >
            EBU-CBU
          </Button>
          {showColumnChart ? (
            <Button disabled color="inherit" size="small" onClick={() => null}>
              Sales
            </Button>
          ) : null}
        </Breadcrumbs>
      ) : null}
      <PieChart
        {...props}
        isHayyak={props.tabIndex === 1}
        showEbuCbu={showEbuCbu}
        showMnpData={props.showMnpData}
        setShowEbuCbu={setShowEbuCbu}
        showColumnChart={showColumnChart}
        setShowColumnChart={setShowColumnChart}
      />
    </div>
  );
}
